import React from 'react'
import PropTypes from 'prop-types'
import { Button, DialogContent } from '@mui/material'

import { get } from 'utils/lodash'
import T from 'T'
import HHBaseDialog from 'components/common/HHBaseDialog'
import HHDialogTitle from 'components/common/HHDialogTitle'
import HHDialogActions from 'components/common/HHDialogActions'
import ContactsListing from 'components/customer-details/content/contacts/ContactsListing'
import { selectAddressName } from 'data/address/addressSelectors'

const LocationContactsDialog = ({ isOpen = false, selectedLocation = {}, onClose }) => {
  const locationAddress = get(selectedLocation, 'address', {})
  const contacts = get(selectedLocation, 'contacts', [])
  const addressName = selectAddressName(locationAddress)

  return (
    <HHBaseDialog open={isOpen} maxWidth="md" fullWidth onClose={onClose}>
      <HHDialogTitle title={addressName || T.CONTACTS} onClose={onClose} />
      <DialogContent sx={{ p: 0 }}>
        <ContactsListing contacts={contacts} showActionMenu={false} noContactMessage={T.NO_LOCATION_CONTACTS} />
      </DialogContent>
      <HHDialogActions>
        <Button variant="contained" onClick={onClose}>
          {T.CLOSE}
        </Button>
      </HHDialogActions>
    </HHBaseDialog>
  )
}

LocationContactsDialog.propTypes = {
  isOpen: PropTypes.bool,
  selectedLocation: PropTypes.object,
  onClose: PropTypes.func.isRequired,
}

export default LocationContactsDialog
